import { useState, useEffect, useCallback } from "react";
import { url } from "../utils/config";
import postData from "../custom_functions/postData";
import Input from "../reusable_components/Input";
import { toast } from "react-toastify";
import Button from "../reusable_components/Button";
import { btnCancel, btnOne, inputStyle, label, modalContainer, modalTitle } from "../utils/style";
import patchData from "../custom_functions/patchData";
import Select from "../reusable_components/Select";
import TextArea from "../reusable_components/TextArea";
import { AiOutlineInfoCircle } from 'react-icons/ai';
import debounce from "lodash.debounce";

function AddFleetCustomer({ otherData, setOtherData, setShowModal, reload, countryConfig }) {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        address: '',
        creditBalance: 0,
        paymentTerms: '',
        phone: '',
        creditLimit: '',
        currency: '',
        country: 'US',
        bypassApproval: false,
        city: '',
        postal_code: '',
        company_name: '',
        state_province: '',
    });
    const [oldFormData, setOldFormData] = useState({});
    const [missingFields, setMissingFields] = useState([]);
    const [inputErrors, setInputErrors] = useState([]);
    const [showInputError, setShowInputError] = useState(false);

    const requiredFields = ['name', 'company_name', 'email', 'address', 'creditLimit', 'paymentTerms', 'phone', 'currency', 'bypassApproval', 'city', 'postal_code', 'state_province'];
    const PHONE_PREFIX = countryConfig?.find(c => c.country === (otherData?.country || formData.country))?.phoneCode || "+1";
    const POSTAL_LABEL = countryConfig?.find(c => c.country === formData.country)?.postalLabel || "ZIP/Postal Code";
    const STATE_LABEL = countryConfig?.find(c => c.country === formData.country)?.stateLabel || "State/Province";
    const COUNTRY_LIST = countryConfig?.map(c => c.country);

    function isValidProvince(code) {
        const validProvinces = countryConfig?.find(c => c.country === formData.country)?.postalCode?.map(p => p.code) || [];
        return validProvinces.includes(code);
    }

    useEffect(() => {
        if (otherData) {
            setFormData({
                ...otherData,
                phone: otherData.phone ? otherData.phone.replace(PHONE_PREFIX, '') : '',
                country: otherData.country || 'US'
            });
            setOldFormData({ ...otherData });

        }
    }, [otherData])

    async function addFleet() {
        setMissingFields([])
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        const hasAlphabet = /[a-zA-Z]/;
        if (formData.phone && hasAlphabet.test(formData.phone)) {
            return toast.error("Phone number cannot contain alphabets", { autoClose: 3000 });
        }

        if (formData.maxDiscount && (Number(formData.maxDiscount) < 0 || Number(formData.maxDiscount) > 100)) {
            return toast.error("Max Discount % must be between 0 and 100", { autoClose: 3000 });
        }

        if (formData.mobile && hasAlphabet.test(formData.mobile)) {
            return toast.error("Mobile number cannot contain alphabets", { autoClose: 3000 });
        }

        const digitsOnly = formData.phone.replace(/\D/g, ""); // remove everything except digits
        if (formData.phone && digitsOnly.length !== 10) {
            return toast.error("Phone number must be 10 digits", { autoClose: 3000 });
        }

        if (formData.name &&
            formData.email &&
            formData.postal_code &&
            formData.country &&
            formData.city &&
            formData.state_province &&
            regex.test(formData.email) &&
            formData.address &&
            formData.creditLimit &&
            formData.bypassApproval &&
            formData.phone &&
            formData.company_name &&
            formData.paymentTerms &&
            formData.currency === 'USD' &&
            !inputErrors.includes('error')
        ) {

            const usZipRegex = /^\d{5}(-\d{4})?$/;
            const caPostalRegex = /^[A-Za-z]\d[A-Za-z][ ]?\d[A-Za-z]\d$/;

            const isValid = formData.country === 'US' ? usZipRegex.test(formData.postal_code) : caPostalRegex.test(formData.postal_code);

            if (!isValid) {
                return toast.error(`Invalid ${POSTAL_LABEL}`, { autoClose: 3000 })
            }
            if (formData.country === 'Canada' && !isValidProvince(formData.state_province)) {
                return toast.error("Invalid Province", { autoClose: 3000 })
            }


            if (formData.creditLimit < 0) {
                return toast.error("Credit limit cannot be negative", { autoClose: 3000 })
            }

            formData.creditLimit = parseFloat(formData.creditLimit);
            formData.phone = `${PHONE_PREFIX}${digitsOnly}`;

            postData(`${url}/fleet_customer`, { ...formData, }, (error) => {
                setFormData({ ...formData, phone: formData.phone?.replace(PHONE_PREFIX, '') });
                toast.error(error.response.data.message, { autoClose: 3000 })
            }, (data) => {
                toast.success(data.message, { autoClose: 3000 })
                setShowModal(false)
                reload(1 + Math.random())
                setFormData({})
            })
        } else {
            const miss = requiredFields.filter(f => !formData[f]);
            setMissingFields(miss);
            setShowInputError(true)
        }
    }


    const updateFleetCustomerApprovalStatus = async (formData, actionType) => {
        formData.previousEmail = otherData?.email || ''
        formData.actionType = actionType;
        formData.phone = `${PHONE_PREFIX}${formData.phone}`;
        patchData(`${url}/fleet_customer/${formData.id}`, formData, (error => {
            toast.error(error.response.data.message, { autoClose: 3000 })
            setOtherData()
            setShowModal(false)
            reload(1 + Math.random())
        }), (data) => {
            setOtherData()
            toast.success(data.message, { autoClose: 3000 })
            setShowModal(false)
            reload(1 + Math.random())
        })

    }

    async function updateFleetCustomer() {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        const hasAlphabet = /[a-zA-Z]/;
        if (formData.phone && hasAlphabet.test(formData.phone)) {
            return toast.error("Phone number cannot contain alphabets", { autoClose: 3000 });
        }

        if (formData.mobile && hasAlphabet.test(formData.mobile)) {
            return toast.error("Mobile number cannot contain alphabets", { autoClose: 3000 });
        }

        if (formData.maxDiscount && (Number(formData.maxDiscount) < 0 || Number(formData.maxDiscount) > 100)) {
            return toast.error("Max Discount % must be between 0 and 100", { autoClose: 3000 });
        }

        const digitsOnly = formData.phone?.replace(/\D/g, ""); // remove everything except digits
        if (digitsOnly.length !== 10) {
            return toast.error("Phone number must be 10 digits", { autoClose: 3000 });
        }

        if (formData.name &&
            regex.test(formData.email) &&
            formData.postal_code &&
            formData.country &&
            formData.city &&
            formData.state_province &&
            formData.phone &&
            formData.company_name &&
            formData.paymentTerms &&
            formData.bypassApproval &&
            formData.address &&
            formData.creditLimit &&
            formData.currency === 'USD' &&
            !inputErrors.includes('error')) {

            const usZipRegex = /^\d{5}(-\d{4})?$/;
            const caPostalRegex = /^[A-Za-z]\d[A-Za-z][ ]?\d[A-Za-z]\d$/;

            const isValid = formData.country === 'US' ? usZipRegex.test(formData.postal_code) : caPostalRegex.test(formData.postal_code);

            if (!isValid) {
                return toast.error(`Invalid ${POSTAL_LABEL}`, { autoClose: 3000 })
            }

            const actionType = [];

            if (oldFormData.bypassApproval !== formData.bypassApproval) {
                actionType.push({
                    type: "APPROVAL_STATUS_CHANGE",
                    previousValue: oldFormData.bypassApproval,
                    newValue: formData.bypassApproval
                });
                // updateFleetCustomerApprovalStatus(formData);
            }
            if (oldFormData.creditLimit !== formData.creditLimit) {
                actionType.push({
                    type: "CREDIT_LIMIT_CHANGE",
                    previousValue: oldFormData.creditLimit,
                    newValue: formData.creditLimit
                });
                // updateFleetCustomerApprovalStatus(formData);
            }

            updateFleetCustomerApprovalStatus(formData, actionType);


        } else {
            const miss = requiredFields.filter(f => !formData[f]);
            setMissingFields(miss);
            setShowInputError(true)
        }
    }


    const fetchZipDetails = useCallback(
        debounce(async (zip) => {
            if (!/^\d{5}$/.test(zip)) return; // only call if exactly 5 digits
            try {
                const res = await fetch(`https://ziptasticapi.com/${zip}`, {
                    headers: { "Accept": "application/json" },
                });
                if (!res.ok) return toast.error("Could not get ZIP details", { autoClose: 3000 })
                const data = await res.json();
                setFormData((prev) => ({
                    ...prev,
                    city: data.city || "",
                    state_province: data.state || "",
                }));
            } catch (err) {
                console.error("ZIP lookup failed:", err);
            }
        }, 500),
        []
    );


    function handlePostalCodeChange(e) {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));

        if (formData.country === "US") {
            fetchZipDetails(value);
        }
    }


    function updateFormData(e) {
        const { name, value } = e.target;
        var data = { ...formData };
        data[name] = value;

        setFormData(data);
    }

    return (
        <div className={modalContainer}>
            <div className="bg-white rounded-lg p-4 w-2/3">
                <div className={`${modalTitle} mb-4`}> Fleet Customer</div>
                <div className="overflow-x-scroll scroll-x-auto max-h-[390px]">
                    <div className="grid grid-cols-6 gap-2 py-1 px-2">
                        <div className="col-span-2">
                            <label className={label}>Name</label>
                            <Input
                                index={1}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                name="name"
                                value={formData.name}
                                type="text"
                                className={inputStyle}
                                placeHolder="Enter Name"
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                        <div className="col-span-2">
                            <label className={label}>Email</label>
                            <Input
                                index={2}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                name="email"
                                value={formData.email}
                                type="email"
                                className={inputStyle}
                                placeHolder="abc@xyz.com"
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                        <div className="col-span-2">
                            <label className={label}>Phone({PHONE_PREFIX})</label>
                            <Input
                                index={3}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                name="phone"
                                value={formData.phone}
                                className={inputStyle}
                                placeHolder="Enter phone"
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-6 gap-2 py-1 px-2">
                        <div className="col-span-2">
                            <label className={label}>Mobile</label>
                            <Input
                                index={13}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={false}
                                name="mobile"
                                value={formData.mobile}
                                className={inputStyle}
                                placeHolder="Enter mobile no"
                                onChange={e => updateFormData(e)}
                            />

                        </div>
                        <div className="col-span-2">
                            <label className={`${label} flex items-center gap-1`} htmlFor="bypassApproval">
                                <div className="relative group cursor-pointer">
                                    <AiOutlineInfoCircle className="w-4 h-4 text-gray-500" />
                                    <div className="absolute left-1/2 -translate-x-1/2 mt-1 w-max px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity z-10 whitespace-nowrap">
                                        Bypass work estimate approval
                                    </div>
                                </div>
                                Bypass Approval
                            </label>
                            <Select
                                index={5}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                name="bypassApproval"
                                value={formData.bypassApproval}
                                className={inputStyle}
                                onChange={e => updateFormData(e)}
                                options={['yes', 'no']}
                            />
                        </div>
                        <div className="col-span-2">
                            <label className={label}>Country</label>
                            <Select
                                index={6}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={false}
                                name="country"
                                value={formData.country}
                                type="text"
                                placeHolder="country"
                                className={inputStyle}
                                onChange={e => updateFormData(e)}
                                options={COUNTRY_LIST}
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-6 gap-2 py-1 px-2">
                        <div className="col-span-2">
                            <label className={label}>{POSTAL_LABEL}</label>
                            <Input
                                index={7}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                name="postal_code"
                                value={formData.postal_code}
                                className={inputStyle}
                                placeHolder={`Enter ${POSTAL_LABEL}`}
                                onChange={handlePostalCodeChange}
                            />

                        </div>
                        <div className="col-span-2">
                            <label className={label}>{STATE_LABEL}</label>
                            <Input
                                index={8}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                // disabled={formData.country === 'US' ? true : false}
                                name="state_province"
                                value={formData.state_province}
                                type="text"
                                className={inputStyle}
                                placeHolder={`Enter ${STATE_LABEL}`}
                                onChange={e => updateFormData(e)}
                            />

                        </div>
                        <div className="col-span-2">
                            <label className={label}>City</label>
                            <Input
                                index={9}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                name="city"
                                // disabled={formData.country === 'US' ? true : false}
                                value={formData.city}
                                type="text"
                                className={inputStyle}
                                placeHolder="Enter city"
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-6 gap-4 py-1 px-2">
                        <div className="col-span-2">
                            <label className={label}>Currency</label>
                            <Select
                                index={10}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                name="currency"
                                value={formData.currency}
                                type="text"
                                placeHolder="Currency"
                                className={inputStyle}
                                validCurrency={['USD']}
                                onChange={e => updateFormData(e)}
                                options={['USD', 'CAD']}
                            />
                        </div>
                        <div className="col-span-2">
                            <label className={label}>Credit Limit</label>
                            <Input
                                index={11}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                name="creditLimit"
                                value={formData.creditLimit}
                                type="number"
                                placeHolder="Credit limit"
                                className={inputStyle}
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                        <div className="col-span-2">
                            <label className={label}>Preferred Contact Method</label>
                            <Input
                                index={12}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={false}
                                name="preferred_contact_method"
                                value={formData.preferred_contact_method}
                                type="text"
                                className={inputStyle}
                                placeHolder="Enter contact method"
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-6 gap-4 py-1 px-2">
                        <div className="col-span-2">
                            <label className={label}>Payment Terms</label>
                            <Select
                                index={4}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                name="paymentTerms"
                                value={formData.paymentTerms}
                                type="text"
                                placeHolder="Payment terms"
                                className={inputStyle}
                                onChange={e => updateFormData(e)}
                                options={['Net 7', 'Net 10', 'Net 30', 'Net 45', 'Net 60', 'Net 90', 'On Receipt']}
                            />
                        </div>

                        <div className="col-span-2">
                            <label className={label}>Max Discount (Default 20%)</label>
                            <Input
                                index={14}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                name="maxDiscount"
                                value={formData.maxDiscount}
                                type="number"
                                className={inputStyle}
                                placeHolder="Max Discount %"
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                        <div className="col-span-2">
                            <label className={label}>Company Name</label>
                            <Input
                                index={15}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                name="company_name"
                                value={formData.company_name}
                                type="text"
                                className={inputStyle}
                                placeHolder="Enter company name"
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-6 gap-2 py-1 px-2">
                        <div className="col-span-2">
                            <label className={label}>Address Line 1</label>
                            <TextArea
                                index={16}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                name="address"
                                value={formData.address}
                                className={inputStyle}
                                placeHolder="Enter Address line 1"
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                        <div className="col-span-2">
                            <label className={label}>Address Line 2</label>
                            <TextArea
                                index={17}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={false}
                                name="address_line2"
                                value={formData.address_line2}
                                className={inputStyle}
                                placeHolder="Enter address line 2"
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                        <div className="col-span-2">
                            <label className={label}>Notes</label>
                            <TextArea
                                index={18}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={false}
                                name="notes"
                                value={formData.notes}
                                className={inputStyle}
                                placeHolder="Enter notes"
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                    </div>
                </div>
                <div className="flex justify-between px-16 gap-8">
                    <button onClick={() => setShowModal(false)} className={btnCancel}>Cancel</button>
                    <Button clickHandler={() => { otherData ? updateFleetCustomer() : addFleet() }} className={btnOne} name={'Submit'} />
                </div>
                <div className="text-red-500 font-semibold text-center">
                    {
                        showInputError && 'Please fill all the fields as directed!'
                    }
                </div>

            </div>
        </div >
    )

}

export default AddFleetCustomer;